import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BsCheckCircleFill, BsChevronDown} from 'react-icons/bs'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

// Gộp mọi buổi ĐÃ diễn ra thành 1 block tóm tắt (thay vì liệt kê từng dòng, dễ rợp mắt khi lịch đã có
// nhiều buổi) - bấm nút để mở/đóng xem lại danh sách chi tiết. Tách ra file DÙNG CHUNG (trước đây định
// nghĩa riêng trong MyClassSessionsPanel.js - tab "Sắp tới" của học viên) vì đúng pattern cũng cần cho
// CourseClassTimetablePanel.js (tab "Theo khai báo" của admin/GV, xem renderItem ở đó) - tránh code
// trùng/lệch UI cho cùng 1 khái niệm "gộp buổi đã qua" ở 2 nơi.
// "Tiến độ hoàn thành" = số buổi ĐÃ DIỄN RA / TỔNG số buổi trong lịch (count/totalSessions) - KHÁC "%
// chuyên cần" (tính riêng ở nơi gọi, dựa trên điểm danh thật, nếu có) - đây là tiến độ ĐI QUA chương
// trình, không phải tỉ lệ có mặt. "Lần học gần nhất" = do nơi gọi tự tính (thường là end_time của buổi
// past cuối cùng, dữ liệu thật, không suy diễn) - truyền sẵn qua prop, component này không tự suy.
export const PastSessionsSummary = ({count, totalSessions, lastStudiedDate, expanded, onToggle}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const progressPercent = totalSessions > 0 ? Math.round((count / totalSessions) * 100) : null

    return (
        <div className={classNames('p-4 flex flex-col gap-3 background-50', expanded && 'border-b border-color-100')}>
            <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                    <div style={{width: 40, height: 40}} className="flex flex-center flex-shrink-0 bg-green-50 border border-green-200 rounded-xl">
                        <BsCheckCircleFill size={20} className="text-green-500"/>
                    </div>
                    <div className="flex flex-col min-w-0 gap-0.5">
                        <div className="flex items-center gap-2">
                            <span className="font-bold text-sm text-gray-800 truncate">{t('session log title')}</span>
                            <span className="px-1.5 py-0.5 rounded-full text-2xs font-semibold bg-green-100 text-green-700 flex-shrink-0">
                                {count} {t('sessions')}
                            </span>
                        </div>
                        {(progressPercent != null || lastStudiedDate) && (
                            <span className="text-2xs text-color-300 tracking-wide truncate">
                                {progressPercent != null && t('completed journey percent', {percent: progressPercent})}
                                {progressPercent != null && lastStudiedDate && ' • '}
                                {lastStudiedDate && `${t('last studied on')}: ${lastStudiedDate}`}
                            </span>
                        )}
                    </div>
                </div>
                <button
                    type="button"
                    onClick={onToggle}
                    style={{ height: 40, minHeight: 40 }}
                    className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold background border border-color-100 hover:border-green-300 text-color-300 hover:text-green-600 whitespace-no-wrap">
                    {isLg && t('view studied sessions', {n: count})}
                    <BsChevronDown
                        size={12}
                        className={classNames('transition-transform duration-200', expanded && 'rotate-180')}
                    />
                </button>
            </div>
            {progressPercent != null && (
                <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between text-2xs text-color-300">
                        <span>{t('completion progress')} ({count}/{totalSessions} {t('sessions')})</span>
                        <span className="font-bold text-color-000">{progressPercent}%</span>
                    </div>
                    <div style={{height: 6}} className="w-full rounded-full background-200 overflow-hidden">
                        <div
                            style={{width: `${progressPercent}%`}}
                            className="h-full rounded-full bg-green-500 transition-all duration-300"
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default PastSessionsSummary
